module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/bft-6e9c45f8794b07031495fe0c8acbf9e8.png";